module.exports = __webpack_public_path__ + "7585c72271a1af890323fbedb3ed901a.mp4";


//////////////////
// WEBPACK FOOTER
// ./assets/videos/Spotin.mp4
// module id = 225
// module chunks = 0